import clsx from 'clsx'
import { useConversationalist } from 'features/messaging/hooks'
import { type ButtonHTMLAttributes, useId, useSyncExternalStore } from 'react'
import { appDay } from 'shared/day'
import { useActionCreators, useAppSelector } from 'shared/hooks'
import { contextActions, typo } from 'shared/styles'
import { StackIcon } from 'shared/ui'

import type { Message } from '../../model/types'

import { actions } from '../../model/slice'
import { selectors } from '../../utils/selectors'
import { EmojiSelect } from '../Emoji/Select'
import css from './MessageActions.module.scss'
import { closeOnBlur, manualSet, onTriggerClose, openId } from './utils'

const isFresh = (day?: string) =>
	Boolean(day) && appDay().diff(day, 'hour') <= 1

export function MessageActions() {
	const menuId = useId()

	const contextId = useSyncExternalStore(openId.subscribe, () => openId.value)
	const message = useAppSelector(state =>
		selectors.messages.selectById(state, contextId)
	)

	const conversationalist = useConversationalist()

	const isInterlocutorsMessage =
		message?.from?.entityId === conversationalist?.entityId

	const showContextMenu =
		!isInterlocutorsMessage && isFresh(message?.created_at)

	return (
		<div
			className={css.root}
			id={menuId}
			onMouseLeave={closeOnBlur}
			// @ts-ignore Recheck in React 19
			popover='manual'
			ref={manualSet}
		>
			<div className={clsx(css.menu, typo.buttonSmB)}>
				{message && <EmojiSelect {...message} />}

				{showContextMenu && <SubActions {...message} />}
			</div>
		</div>
	)
}

function SubActions({ message_id: id = '', text = '' }: Message) {
	const subActions = useId()
	const { setEditMessage, setMessageToDelete } = useActionCreators(actions)

	const actionProps = {
		className: contextActions.action,
		popovertarget: subActions,
		popovertargetaction: 'hide',
		type: 'button'
	} as ButtonHTMLAttributes<HTMLButtonElement>

	return (
		<>
			<button
				aria-haspopup='true'
				aria-label='Open menu'
				className={`li-⚪ ${css.subTrigger}`}
				onBlur={onTriggerClose}
				onMouseLeave={onTriggerClose}
				// @ts-ignore
				popovertarget={subActions}
				popovertargetaction='toggle'
				type='button'
			>
				<StackIcon icon='dots' stack='linkedin' />
			</button>
			<div
				className={clsx(css.subMenu, contextActions.menu, typo.buttonSmB)}
				id={subActions}
				// @ts-ignore Recheck in React 19
				popover='auto'
			>
				<button onClick={() => setMessageToDelete(id)} {...actionProps}>
					Delete
				</button>

				<button
					onClick={() =>
						setEditMessage({
							id,
							text
						})
					}
					{...actionProps}
				>
					Edit
				</button>
			</div>
		</>
	)
}
